import styled from 'styled-components';

export const ShareBtnWrapper = styled.div`
  margin-right: 20px;
`;
